import styled from "@emotion/styled";
import { ViewIcon } from "components/Icons";
import { Spacer } from "components/general/Spacer/Spacer";
import { Text } from "components/general/Text";
import { TransactionDetail } from "types/history";
import { openTransactionInBlockExplorer } from "utils/txUtils";

interface ViewTxBtnProps {
  chainId: TransactionDetail["chain_id"];
  txHash: TransactionDetail["txHash"];
}

export const ViewTxBtn = ({ chainId, txHash }: ViewTxBtnProps) => {
  return (
    <Button onClick={() => openTransactionInBlockExplorer(chainId, txHash)}>
      <ViewIcon width={21} height={21} strokeWidth={1.5} />
      <Spacer width="6px" />
      <Text textStyle="Button" size="Medium">
        View Transaction
      </Text>
    </Button>
  );
};

// Sub-components

const Button = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 48px;
  border: none;
  border-radius: 14px;
  padding: 13px 16px 13px 10px;
  color: ${props => props.theme.button.secondary.text.default};
  background-color: ${props => props.theme.button.secondary.surface.default};
  transition: background-color 150ms linear;

  &:hover {
    background-color: ${props => props.theme.button.secondary.surface.hover};
    color: ${props => props.theme.button.secondary.text.hover};
  }
`;
